import DatabaseModel from './DatabaseModelOffline.js';

var Equipo = Object.create(DatabaseModel);

Equipo.model = 'equipos';

export default Equipo;